module.exports = __webpack_public_path__ + "media/images/logo-hand-b379dbb70d98c2279a301266890aa38c.png";